import { Button, Menu, Dropdown } from "antd"
import { EllipsisOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"

ActionButton.propTypes = {
  onAlias: PropTypes.func,
  onRecovery: PropTypes.func,
  onEdit: PropTypes.func,
  onDisabled: PropTypes.func,
  roles: PropTypes.array,
  disabled: PropTypes.bool,
  onDelete: PropTypes.func,
  enableDelete: PropTypes.bool
}

export function ActionButton({ onAlias, onRecovery, onEdit, onDisabled, roles, disabled, onDelete, enableDelete, ...props }) {
  const menu = (
    <Menu>
      <Menu.Item onClick={onAlias}>
        Editar usuario
      </Menu.Item>
      <Menu.Item onClick={onRecovery}>
        Recuperar contraseña
      </Menu.Item>
      {roles[0]?.role?.includes("ADMIN") && (
        <Menu.Item onClick={onEdit}>
          Cambiar a implementadora
        </Menu.Item>
      )}
      <Menu.Item onClick={onDisabled}>
        {!disabled ? "Desactivar cuenta" : "Activar cuenta"}
      </Menu.Item>
      {enableDelete ? (
        <Menu.Item onClick={onDelete}>
          Eliminar cuenta
        </Menu.Item>
      ) : null}
    </Menu>
  )

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <Button
        shape="circle"
        icon={<EllipsisOutlined />}
        {...props} />
    </Dropdown>
  )
}
